<template>
    <div class="body-panel dataContent">
        <div class="body-panel-control separator">
            <div class="control-block-left">
                <div class="flex mob-inline">
                    <project-select @onChange="onProjectChange" :user="info.User" v-if="info.User && (info.User.MainRole === 'administrators' || info.ProjectsLength > 1)"></project-select>
                    <div class="form-field margin-right-20">
                        <drop-down class=""
                                   :items="statuses"
                                   :dataField="'Id'"
                                   :textField="'Name'"
                                   v-model="statusId"
                                   @change="onStatusChange($event)"></drop-down>
                    </div>
                    <div class="form-field margin-right-20">
                        <drop-down class=""
                                   :items="dateTypes"
                                   :dataField="'Id'"
                                   :textField="'Name'"
                                   v-model="dateTypeId"
                                   @change="onStatusChange($event)"></drop-down>
                    </div>
                    <div class="form-field flex mob-inline">
                        <input-date name="dateStart" v-model="dateStart" @input="onDateChange" class="input-text input-date"></input-date>
                        <span class="margin-left-10 margin-right-10 margin-top-5">-</span>
                        <input-date name="dateEnd" v-model="dateEnd" @input="onDateChange" class="input-text input-date"></input-date>
                    </div>
                    <div class="form-field margin-left-20" v-if="statusId || dateStart || dateEnd || dateTypeId">
                        <button type="button" class="btn" @click="clearFilterState">Сбросить</button>
                    </div>
                </div>
            </div>
            <div class="control-block-right btns flex">
                <div style="margin: auto 10px;" v-if="selectedReports.length">
                    Выбрано {{ selectedReports.length }} из {{ totalCount }}
                </div>
                <button class="btn" @click="onExport()" v-if="info.User && !hasClaims(info.User.DynamicRole, claimEnums.reportAdd) && reports.length > 0">
                    Экспорт
                </button>
                <button class="btn" @click="onAddReport" v-if="info.User && hasClaims(info.User.DynamicRole, claimEnums.reportAdd)">Добавить отчет</button>
                <button type="button" class="btn btn-primary" @click="tryApproveReports(2, '')" v-if="selectedReports.length">Принять</button>
                <button type="button" class="btn btn-delete" @click="sendReportsToEditionModal()" v-if="selectedReports.length">Доработать</button>
                <button type="button" class="btn btn-delete" @click="rejectReportsModal()" v-if="selectedReports.length">Отклонить</button>
                <button type="button" class="btn" @click="selectedCancel()" v-if="selectedReports.length">Отмена</button>
            </div>

            <div class="body-panel-control-separator">

                <complex-filter ref="complexFilter"
                                :cacheKey="'reportsComplexFilter'"
                                :filters="userFilters"
                                :searchFunction="searchFunction"
                                :tableName="'[dbo].[AspNetUsers]'"
                                @onFilterChange="onFilterChange"
                                :withTableNameInClause="true"></complex-filter>
            </div>
        </div>
        <div class="body-panel-content body-panel-content-page" v-if="reportSettingsLoaded" @scroll="onScroll">
            <table class="table-view" id="dataTable">
                <thead>
                    <tr class="heading">
                        <th class="check" v-if="info.User && info.User.MainRole === 'administrators'">
                            <input id="selectAll" name="selectAll" value="true" type="checkbox" class="input-checkbox"
                                   v-model="selectAll" @change="onSelectAllChange($event)" />
                            <label for="selectAll" class="input-checkbox-lbl"></label>
                        </th>
                        <th>Id</th>
                        <th>Пользователь</th>
                        <th>Статус</th>
                        <th>Дата</th>
                        <th>Дата изменения статуса</th>
                        <th v-for="header of headerColumns">{{ header.caption }}</th>
                        <th v-if="reportType === ReportTypes.QrCode">
                            Чек и фото
                        </th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, i) of reports" @click="openReport(item)">
                        <td class="check" @click.stop="" v-if="info.User && info.User.MainRole === 'administrators'">
                            <input :id="'select' + i" :value="item" type="checkbox" class="input-checkbox" v-model="selectedReports" @change="onCheckChange(item)" />
                            <label :for="'select' + i" class="input-checkbox-lbl"></label>
                        </td>
                        <td class="id">{{item.Id}}</td>
                        <td class="userimg">
                            <span class="user-icon-login">
                                {{ item.Seller.Fio }}
                            </span>
                        </td>
                        <td :class="['state', getStateClass(item)]">{{ item.StateFormatted }}</td>
                        <td class="date">
                            {{ item.CreateDate | date-short }}
                        </td>
                        <td class="date">
                            {{ item.LastModifiedDate | date-short }}
                        </td>
                        <td class="value" v-for="sumItem of item.SummaryItems" v-if="reportSettings">
                            {{ sumItem.Value }}
                        </td>
                        <td v-if="reportType === ReportTypes.QrCode">
                            <a class="report-photo"
                               :rel="'reportphoto' + i"
                               v-for="photo of item.Photos"
                               :href="photo.FileName"
                               @click.stop="">
                                <img :src="photo.FileName" />
                            </a>
                        </td>
                        <td class="value">
                            <button type="button" class="btn" @click.stop="openNewTab(item.Id)" title="Открыть в новой вкладке">Открыть</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <popup-window ref="ppEditModal" :title="'Отправка на доработку'" :modal="true">
            <div class="form-group">
                <label class="input-text-lbl">
                    Причина отправки на доработку
                    <span class="required" aria-required="true">*</span>
                </label>
                <textarea name="EditionComment" rows="10" style="height:150px;"
                          :class="['input-memo', { 'input-error': errors.has('EditionComment', 'edition') }]"
                          v-model="editionComment"
                          data-vv-scope="edition"
                          v-validate="'required'"></textarea>
                <span class="field-validation-valid" v-if="errors.has('EditionComment', 'edition')">Заполните поле</span>
            </div>
            <div class="btns flex margin-top-20" data-toggle="buttons">
                <button type="button" class="btn btn-primary" @click.stop="sendReportsToEdition()">Принять</button>
                <button type="button" class="btn" @click.stop="closeModal('ppEditModal')">Отмена</button>
            </div>
        </popup-window>
        <popup-window ref="ppRejectModal" :title="'Отклонение отчётов'">
            <div class="form-group">
                <label class="input-text-lbl">
                    Укажите причину отклонения
                    <span class="required" aria-required="true">*</span>
                </label>
                <textarea name="CancellationComment" rows="10" style="height:150px;"
                          :class="['input-memo', { 'input-error': errors.has('CancellationComment', 'rejection') }]"
                          data-vv-scope="rejection"
                          data-vv-as="Причина отклонения"
                          v-model="editionComment"
                          v-validate="{required: true, min: 3}"></textarea>
                <span class="field-validation-valid">{{errors.first('CancellationComment', 'rejection')}}</span>
            </div>
            <div class="btns flex margin-top-20" data-toggle="buttons">
                <button type="button" class="btn btn-primary"
                        @click="rejectReports()">
                    Отклонить
                </button>
                <button type="button" class="btn" @click="closeModal('ppRejectModal')">Отмена</button>
            </div>
        </popup-window>
        <popup-window ref="ppApprovedResultModal" :title="'Результат изменения'">
            <div v-if="approvedResult != null">
                Успешно изменено строк: {{ approvedResult.changed.length }}
                <br>
                <br>
                <template v-if="approvedResult.skipped.length">
                    По следующим отчетам статус не был изменен:
                    <br>
                    <ul>
                        <li v-for="id of approvedResult.skipped">
                            {{id}}
                        </li>
                    </ul>
                </template>
            </div>
            <div class="btns flex margin-top-20" data-toggle="buttons">
                <button type="button" class="btn" @click="closeModal('ppApprovedResultModal')">Ok</button>
            </div>
        </popup-window>

        <vue-headful :title="getPageTitle()" />
    </div>
</template>

<script>
    import $ from 'jquery'
    import 'datatables.net'
    import BackendApi from '../backendApi'
    import UI from '../helpers/ui-helpers'
    import moment from 'moment'
    import config from '../config'
    import projectMixin from '../helpers/project-mixin'
    import {ReportTypes} from '../enums'
    import fancybox from '../assets/FancyBox/jquery.fancybox.pack.js'
    import fancyboxcss from '../assets/FancyBox/jquery.fancybox.css'

    let backendApi = new BackendApi();
    let DateTypes = {
        /*
        Дата заполнения
         */
        FillingDate: 1,
        /*
        Дата отчета
         */
        ReportDate: 2,
        /*
        Дата изменения статуса
         */
        StatusDate: 3
    };

    let processFilter = function (filter) {
        let resultFilter = JSON.parse(JSON.stringify(filter));
        if (resultFilter) {
            for (let item of resultFilter) {
                let filterField = item[0];
                if (filterField === '[dbo].[AspNetUsers].[r.Id]') {
                    item[0] = 'r.[Id]';
                    item[2] = item[2].replace(new RegExp('\'', 'g'), '');
                }
            }
        }
        return resultFilter;
    };

    let cacheKey = 'reportsFilter';

    export default {
        name: "reports",

        props: ['info'],

        mixins: [projectMixin], // projectId

        data(){
            return{
                statusId: DateTypes.FillingDate,
                dateTypeId: null,
                dateStart: null,
                dateEnd: null,
                reportSettingsLoaded: false,
                reportSettings: null,
                reportType: null,
                statuses: [
                    {Id: 0, Name: 'Все отчеты'}, {Id: 1, Name: 'Не проверенные'}, {Id: 2, Name: 'Проверенные'},
                    {Id: 3, Name: 'Доработанные'}, {Id: 4, Name: 'На доработке'}, {Id: 5, Name: 'Отклоненные'},
                ],
                dateTypes: [
                    {Id: DateTypes.FillingDate, Name: ' Дата заполнения'},
                    {Id: DateTypes.ReportDate, Name: 'Дата отчета'},
                    {Id: DateTypes.StatusDate, Name: 'Дата изменения статуса'}
                ],
                page: 1,
                reports: [],
                projectId: null,
                ReportTypes:ReportTypes,
                scrollTop: null,
                firstLoad: true,
                loading: false,
                canBeLoaded: true,
                filter: null,
                userFilters: [
                    {
                        Value: 'LastName', Name: 'Фамилия'
                    },
                    {
                        Value: 'FirstName', Name: 'Имя'
                    },
                    {
                        Value: 'MiddleName', Name: 'Отчество'
                    },
                    {
                        Value: 'r.Id', Name: 'Id отчёта'
                    }
                ],
                selectAll: false,
                selectedReports: [],
                editionComment: '',
                approvedResult: {
                    skipped: [], changed: []
                },
                totalCount: 0
            }
        },

        computed: {
            headerColumns: function () {
                if (!this.reportSettings) {
                    return [];
                }
                return this.reportSettings.filter((item) => {
                    return item.showInReportList === true;
                });
            }
        },

        methods: {
            openNewTab(id){
                window.open('/reports/' + (this.info.ReportType === ReportTypes.QrCode ? 'fns/' : '') + id);
            },

            getStateClass(item) {
                switch (item.State) {
                    case 1:
                        return 'not-approved';
                    case 2:
                        return 'approved';
                }
            },

            onAddReport() {
                this.$router.push('/reports/' + (this.info.ReportType === ReportTypes.QrCode ? 'fns/' : '') + '0');
            },

            onStatusChange() {
                this.reload();
                this.saveFilterState();
            },

            onDateChange(){
                this.reload();
                this.saveFilterState();
            },

            onProjectChange(item) {
                let vm = this;

                vm.filter = null;
                vm.$refs['complexFilter'].clear();

                vm.projectId = item.Id;
                vm.statusId = '';
                vm.dateTypeId = DateTypes.FillingDate;
                vm.dateStart = '';
                vm.dateEnd = '';
                vm.scrollTop = null;
                vm.saveFilterState();

                vm.loadSettings().then(function () {
                    vm.reload();

                    vm.$emit('user-updated');
                });
            },

            openReport(item) {
                this.saveFilterState();
                this.$router.push('/reports/' + (this.reportType === ReportTypes.QrCode ? 'fns/' : '') + item.Id);
            },

            reload() {
                this.page = 1;
                this.reports = [];
                this.loading = false;
                this.canBeLoaded = true;

                this.loadNext();
            },

            onExport() {
                let vm = this;
                let dateStart = moment(vm.dateStart, 'DD.MM.YYYY').format();
                let dateEnd = moment(vm.dateEnd, 'DD.MM.YYYY').format();

                let resultFilter = processFilter(vm.filter);
                if (vm.selectedReports.length > 0) {
                    if (!resultFilter) {
                        resultFilter = [];
                    }
                    let ids = _.map(vm.selectedReports, function (item) {
                        return item.Id;
                    });
                    resultFilter.push(['r.[Id]', 'IN', '(' + ids.join(';') + ')']);
                }

                UI.blockUI('#app');
                vm.callApiWrapper(backendApi.reportExport(vm.projectId, resultFilter, vm.statusId, vm.dateTypeId, dateStart, dateEnd))
                    .then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время экспорта отчётов');
                        }
                        else {
                            UI.downloadFileByBytes(resp.data, 'Отчёты.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                                //iOS Chrome
                                //var reader = new FileReader();
                                //reader.onload = function (e) {
                                //    location.href = reader.result;
                                //}
                                //reader.readAsDataURL(blob);
                        }

                        UI.unblockUI('#app');
                    });
            },

            loadNext() {
                let vm = this;
                let rowsPerPage = 25;

                this.loading = true;
                UI.blockUI('.dataContent', 'Загрузка...');
                let timeZone = new Date().getTimezoneOffset();
                let dateStart = moment(vm.dateStart, 'DD.MM.YYYY').add(-timeZone, 'minutes').toISOString();
                let dateEnd = moment(vm.dateEnd, 'DD.MM.YYYY').add(-timeZone, 'minutes').toISOString();

                let skip = (vm.page - 1) * rowsPerPage;
                let take = rowsPerPage;
                if (vm.firstLoad && vm.page > 1) {
                    skip = 0;
                    take = vm.page * rowsPerPage;
                }

                this.callApiWrapper(backendApi.reportList(skip, take, vm.projectId, vm.statusId, vm.dateTypeId, dateStart, dateEnd, processFilter(vm.filter)))
                    .then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            //UI.toastr.error('Ошибка во время загрузки отчётов');
                        } else {
                            if (resp.data.list && resp.data.list.length) {
                                vm.reports.push(...resp.data.list);
                                vm.totalCount = resp.data.totalCount;

                                console.info('[vm.firstLoad, vm.scrollTop]', [vm.firstLoad, vm.scrollTop])
                                if (vm.firstLoad) {
                                    vm.firstLoad = false;
                                    if (vm.scrollTop) {
                                        $('.body-panel-content').animate({scrollTop: vm.scrollTop}, 500, ()=>{
                                            // перезаписываем значение после анимации, чтобы не было скролла при перезагрузке
                                            vm.scrollTop=0;
                                            vm.saveFilterState();
                                        });
                                    }
                                }

                                if (vm.selectAll && vm.selectedReports.length < vm.reports.length) {
                                    vm.selectAll = false;
                                }

                                if (vm.selectedReports.length > 0) {
                                    let reportIds = _.map(vm.reports, function (item) {
                                        return item.Id;
                                    });
                                    _.remove(vm.selectedReports, function (item) {
                                        return _.indexOf(reportIds, item.Id) === -1
                                    });
                                }
                            } else {
                                vm.canBeLoaded = false;
                            }
                        }
                        UI.unblockUI('.dataContent');
                        vm.loading = false;

                        vm.$nextTick(() => {
                            $('.report-photo').fancybox({

                            });
                        });
                    })
            },

            loadSettings() {
                let vm = this;

                return vm.callApiWrapper(backendApi.reportSettingsList(vm.projectId))
                    .then(function (resp) {
                        vm.reportSettings = resp.data.reportSettings;
                        vm.reportType = resp.data.ReportType;
                        vm.reportSettingsLoaded = true;

                        //vm.dateStart = vm.formatDate(moment().startOf('month'));
                        //vm.dateEnd = vm.formatDate(moment().endOf('month'));
                        return resp;
                    })
                    .catch((err) => {
                        console.info(err)
                    });
            },

            clearFilterState(){
                this.dateStart = '';
                this.dateEnd = '';
                this.statusId = '';
                this.dateTypeId = DateTypes.FillingDate;

                localStorage.removeItem(cacheKey);
                this.reload();
            },

            saveFilterState() {
                console.info('this.statusId:', this.statusId);

                let stateObj = {
                    statusId: this.statusId,
                    dateTypeId: this.dateTypeId,
                    dateStart: this.dateStart,
                    dateEnd: this.dateEnd,
                    projectId: this.projectId,
                    page: this.page,
                    scrollTop: this.scrollTop
                };
                localStorage.setItem(cacheKey, JSON.stringify(stateObj));
            },

            recoverFilterState() {
                let stateObj = JSON.parse(localStorage.getItem(cacheKey));
                console.info('recoverFilterState -> stateObj:', stateObj);
                if (stateObj) {
                    if(stateObj.statusId != null) {
                        this.statusId = stateObj.statusId;
                    }
                    if(stateObj.dateTypeId) {
                        this.dateTypeId = stateObj.dateTypeId;
                    }
                    if(stateObj.dateStart) {
                        this.dateStart = stateObj.dateStart;
                    }
                    if(stateObj.dateEnd) {
                        this.dateEnd = stateObj.dateEnd;
                    }
                    if (stateObj.projectId == this.projectId) {
                        if (stateObj.page) {
                            this.page = stateObj.page;
                        }
                        if (stateObj.scrollTop) {
                            this.scrollTop = stateObj.scrollTop;
                        }
                    }
                }

            },

            onScroll(e){
                let vm = this;
                if (!vm.loading && vm.canBeLoaded) {
                    let elem = $(e.target);
                    vm.scrollTop = elem.scrollTop();
                    if (elem[0].scrollHeight - elem.scrollTop() <= elem.outerHeight() + 100) {
                        vm.page++;
                        vm.loadNext();
                    }
                }
            },

            searchFunction(tableName, columnName, search, filters, searchPage, callback) {
                if(columnName === 'TermsConfirmed' || columnName === 'PersonalDataEditingAccept' || columnName === 'NotificationsEnabled')
                {
                    callback(['Да', 'Нет']);
                }
                else if(columnName === 'PassportVerificationState'){
                    callback(['документы отсутствуют', 'проверь документы!', 'документы подтверждены', 'документы возвращены']);
                }
                else if(columnName === 'RegisterStatus'){
                    callback(['неактивен', 'проверка', 'активен', 'отказано', 'отключен', 'заблокирован']);
                }
                else {
                    let filterFormatted = '';
                    if(filters){
                        filterFormatted = processFilter(filters).map(x => {return JSON.stringify(x)});
                    }

                    this.callApiWrapper(backendApi.reportDistinctValues(columnName, this.projectId, search, filterFormatted,
                        (searchPage - 1) * 30, 30))
                        .then(function (resp) {
                            callback(resp.data);
                        })
                }
            },

            onFilterChange(filter) {
                this.filter = filter;
                this.reports = [];
                this.loading = false;
                this.canBeLoaded = true;
                this.page = 1;

                this.loadNext();
            },

            onSelectAllChange(e) {
                let vm = this;

                vm.selectedReports = [];
                if (vm.selectAll) {
                    for (let report of vm.reports) {
                        vm.selectedReports.push(report);
                    }
                }
            },

            onCheckChange(item) {
                let vm = this;
                if (vm.selectedReports.filter(x => x == item).length === 0) {
                    vm.selectAll = false;
                } else if (vm.selectedReports.length === vm.reports.length) {
                    vm.selectAll = true;
                }
            },

            // принятие отчётов
            tryApproveReports(state, comment) {
                let vm = this;
                if (vm.selectedReports.length === 0)
                    return;

                let saveObj = this.selectedReports.map(x => {
                    return {
                        Id: x.Id,
                        State: state,
                        EditionComment: comment
                    }
                });
                console.info('tryApproveReports', saveObj);

                UI.blockUI('.dataContent', 'принятие отчётов...');
                backendApi.reportMultipleApprove(saveObj).then(function (resp) {
                    UI.unblockUI('.dataContent');
                    if (resp.hasError) {
                        UI.toastr.error('Ошибка при сохранении');
                    } else {
                        vm.approvedResult = resp.data;
                        vm.editionComment = '';
                        if (vm.approvedResult.changed.length > 0) {
                            UI.toastr.success('Успешно сохранено');
                            vm.selectedReports = [];
                            vm.reload();
                        }
                        vm.$refs['ppApprovedResultModal'].show();
                    }
                });
            },

            //показываем окно с вводом комментария
            sendReportsToEditionModal() {
                let vm = this;
                vm.$nextTick(() => {
                    vm.$refs.ppEditModal.show();
                });
            },

            // отправка на доработку
            sendReportsToEdition() {
                let vm = this;
                vm.$validator.validateAll('edition').then(result => {
                    if (result) {
                        vm.tryApproveReports(4, vm.editionComment);
                        vm.$refs['ppEditModal'].close();
                    }
                });
            },

            rejectReportsModal() {
                let vm = this;
                vm.$nextTick(() => {
                    vm.$refs.ppRejectModal.show();
                });
            },

            rejectReports() {
                let vm = this;
                vm.$validator.validateAll('rejection').then(result => {
                    if (result) {
                        this.$refs.ppRejectModal.close();
                        vm.tryApproveReports(5, vm.editionComment);
                    }
                });
            },

            selectedCancel() {
                this.selectAll = false;
                this.selectedReports = [];
            }
        },

        mounted () {
            let vm = this;

            vm.recoverFilterState();
            vm.filter = vm.$refs['complexFilter'].getExpotData();

            vm.$nextTick(() => {

                vm.loadSettings().then(function(resp){
                    vm.loadNext();
                });

            })
        }
    }
</script>

<style scoped>
    .table-view thead{
        display: table-header-group;
    }
    .table-view td{
        text-align: center;
    }

    .report-photo{
        width: 100px;
        display: inline-block;
    }
    .report-photo img{
        width: 100%;
    }
    .report-photo + .report-photo{
        margin-left: 10px;
    }
</style>



// WEBPACK FOOTER //
// Content/src/views/Reports.vue